module.exports = __webpack_public_path__ + "static/img/champ-banner-betting-history.e324b08.jpg";